import { putMethodWithTokenWithFormData } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE';

// Action Creators
export const fetchUpdateCategory = () => ({
  type: UPDATE_CATEGORY,
});

export const fetchUpdateCategorySuccess = (data) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: data,
});

export const fetchUpdateCategoryFailure = (error) => ({
  type: UPDATE_CATEGORY_FAILURE,
  payload: error,
});

// Thunk Function
export const updateCategoryCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateCategory(data, external));
    try {
      const response = await putMethodWithTokenWithFormData(
        url.updateCategoryListSuperAdmin + external?.id + '/' + 'update' + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateCategorySuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateCategoryFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateCategoryFailure(error.message));
    }
  };
};
